<template>
  <div class="project-create-view">
    <app-view-layout header="Nowy Projekt">
      <template #content>
        <v-form
          ref="createProjectForm"
          v-model="isFormValid"
          @submit.prevent="submit"
        >
          <ProjectFormCard
            v-model="project"
            class="mt-4 mb-12"
          />

          <ProjectCampaignsCard
            v-if="tagsAndCampaignsAddingPermitted"
            v-model="project.campaignIds"
            class="mb-8"
            editable
          />

          <ProjectTagsCard
            v-if="tagsAndCampaignsAddingPermitted"
            v-model="project.tagIds"
            class="mb-8"
            editable
          />

          <AppTextCard
            v-model="project.description"
            class="mb-8"
            required
            title="Opis projektu *"
          />

          <AppTextCard
            v-model="project.copy"
            class="mb-8"
            title="Tekst do wykorzystania"
          />

          <ProjectFilesCard
            ref="projectFiles"
            :files="files"
            hide-tabs
            disable-download
            :processing="isProcessing"
            @add="showFileAddDialog"
            @delete="deleteFiles"
          />

          <v-checkbox
            v-if="revisionPermitted"
            v-model="project.adminReview"
            dense
            hide-details
          >
            <template #label>
              <span class="caption">Przesłać brief do akceptacji przez Dyrekcję DKO</span>
            </template>
          </v-checkbox>

          <v-btn
            class="my-5"
            color="primary"
            type="submit"
            height="40"
            max-width="120"
            :loading="isProcessing"
          >
            Wyślij projekt
          </v-btn>
        </v-form>
      </template>
    </app-view-layout>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import validationRules from '@/helpers/validators';
import AppViewLayout from '@/components/Layout/AppViewLayout.vue';
import ProjectFormCard from '@/components/Projects/ProjectFormCard.vue';
import AppTextCard from '@/components/UI/AppTextCard.vue';
import ProjectFilesCard from '@/components/Projects/ProjectFilesCard.vue';
import ProjectTagsCard from '@/components/Projects/ProjectTagsCard.vue';
import ProjectCampaignsCard from '@/components/Projects/ProjectCampaignsCard.vue';

export default {
  components: {
    AppViewLayout,
    ProjectFormCard,
    AppTextCard,
    ProjectFilesCard,
    ProjectTagsCard,
    ProjectCampaignsCard,
  },

  data() {
    return {
      rules: validationRules,
      isFormValid: true,
      project: {
        name: '',
        projectType: '',
        mediumIds: [],
        tagIds: [],
        campaignIds: [],
        deadline: '',
        description: '',
        discLocation: '',
        copy: '',
        priority: 'Standardowy',
        printCoordination: false,
      },
    };
  },

  computed: {
    ...mapState('newProject', [
      'isProcessing',
    ]),
    ...mapState('files', [
      'files',
    ]),
    ...mapGetters('auth', [
      'checkUserPermissions',
    ]),

    tagsAndCampaignsAddingPermitted() {
      const availability = ['admin_director', 'chief'];
      return this.checkUserPermissions(availability);
    },

    revisionPermitted() {
      return this.checkUserPermissions(['chief']);
    },
  },

  beforeDestroy() {
    this.clearTempFiles();
    this.changeProcessingStatus(false);
  },

  methods: {
    ...mapActions('newProject', [
      'createProject',
      'changeProcessingStatus',
    ]),
    ...mapActions('files', [
      'deleteTempFiles',
      'clearTempFiles',
    ]),
    ...mapActions('dialog', [
      'showDialog',
    ]),
    ...mapActions('snackbar', [
      'showSnackbar',
    ]),

    submit() {
      this.$refs.createProjectForm.validate();

      if (this.isFormValid) {
        this.createProject({
          ...this.project,
          files: this.files.map((el) => el.data),
        });
      } else {
        this.$vuetify.goTo(0);
        this.showSnackbar({
          message: ['Występują błędy/braki w formularzu'],
          type: 'error',
        });
      }
    },

    showFileAddDialog() {
      this.showDialog({
        header: 'Dodawanie pliku',
        text: 'Wybierz plik i dodaj do projektu.',
        component: 'FileAdd',
      });
    },

    deleteFiles(fileIds) {
      this.deleteTempFiles(fileIds);
      this.$refs.projectFiles.clearSelection();
    },
  },
};
</script>
